import $ from 'jquery';
import '@/assets/vendor/bootstrap-4.0.0/js/bootstrap.bundle.min.js'

/**
 * Popover tooltip as a directive.
 * 
 * Usage: Add the following property to any element. 
 *  No need to do anything else, the directive takes care of initializing and disposing the element
 *    v-popover="'Plaintext contents'" 
 *    v-popover="`<strong>HTML</strong> contents`" 
 */
export default {
  bind(el, binding) {
    $(el).attr({
      'data-toggle': 'popover',
      'data-placement': 'top',
      'data-trigger': 'hover',
      'data-html': 'true',
      'data-content': binding.value
    });
    $(el).popover();
  },
  update(el, binding) {
    if (binding.oldValue !== binding.value) {
      $(el).attr('data-content', binding.value);

      // Destroy and re-initialize the popover to reflect updated content
      $(el).popover('dispose');
      $(el).popover();
    }
  },
  unbind(el) {
    $(el).popover('dispose');
  }
};
